import api from "@/api";
import { useAuth } from "@/store/authStore";

type AuthTokens = {
  access: string;
  refresh: string;
};

export async function loginWithTelegram(): Promise<AuthTokens> {
  const { initData, setTokens } = useAuth.getState();

  if (!initData) {
    throw new Error("Telegram initData not set");
  }

  const resp = await api.post<AuthTokens>(
    "/users/auth/telegram/",
    {},
    {
      headers: {
        "X-Telegram-Init-Data": initData,
      },
    }
  );

  setTokens(resp.data.access, resp.data.refresh, "telegram");

  return resp.data;
}

export async function loginWithTelegramId(
  telegramId: string | number
): Promise<AuthTokens> {
  const resp = await api.post<AuthTokens>("/users/auth/telegram-id/", {
    telegram_id: telegramId,
  });

  useAuth.getState().setTokens(resp.data.access, resp.data.refresh, "telegram");

  return resp.data;
}

export async function loginWithEmail(email: string, password: string) {
  const resp = await api.post<AuthTokens>("/users/auth/email/login/", {
    email,
    password,
  });
  return resp.data;
}

export async function registerWithEmail(email: string, password: string) {
  const resp = await api.post<{ ok: true }>("/users/auth/email/register/", {
    email,
    password,
  });
  return resp.data;
}

export async function resendVerification(email: string) {
  const resp = await api.post<{ ok: true }>(
    "/users/auth/email/resend-verification/",
    {
      email,
    }
  );
  return resp.data;
}

/** Код из письма (6 цифр): подтвердить почту и войти, или войти без пароля. */
export async function confirmEmailCode(email: string, code: string) {
  const resp = await api.post<AuthTokens>("/users/auth/email/confirm-code/", {
    email,
    code,
  });
  return resp.data;
}

export async function confirmEmailToken(token: string) {
  const resp = await api.post<AuthTokens>("/users/auth/email/confirm/", {
    token,
  });
  return resp.data;
}

/** Вход на сайте через подтверждение в Telegram (код + мини-апп, как у приложения BK VPN). */
export type TelegramWebLogin = {
  login_id: number;
  poll_secret: string;
  code: string;
  telegram_link: string;
  expires_at: string;
};

export type TelegramWebLoginPoll = {
  status: "pending" | "expired" | "used" | "ok";
  access?: string;
  refresh?: string;
};

export async function startTelegramWebLogin(): Promise<TelegramWebLogin> {
  const resp = await api.post<TelegramWebLogin>("/app/web-login/start/", {});
  return resp.data;
}

export async function pollTelegramWebLogin(
  login: Pick<TelegramWebLogin, "login_id" | "poll_secret">
): Promise<TelegramWebLoginPoll> {
  const resp = await api.post<TelegramWebLoginPoll>("/app/web-login/poll/", {
    login_id: login.login_id,
    poll_secret: login.poll_secret,
  });
  return resp.data;
}
